import { useQuery } from "@tanstack/react-query";
import { imagineStore } from "@/stores/imagine.store";
import { useImagineChat } from "@/providers/imagine-chat-provider";
import { aiServiceFetch } from "@/lib/ai-service-client";
import { HttpError } from "@/lib/http-error";

export const useProjectWorkspacePreview = ({
  disabled,
}: {
  disabled?: boolean;
}) => {
  const project = imagineStore.use.project();
  const isReadonly = imagineStore.use.isReadonly();
  const { isGenerating } = useImagineChat();
  const projectId = imagineStore.use.projectId();
  const previewUrl = imagineStore.use.previewState.previewUrl();
  const isGeneratingNewProject = imagineStore.use.isGeneratingNewProject();
  const isRealtimeConnected = imagineStore.use.isRealtimeConnected();
  const workspaceStateSteps = imagineStore.use.workspaceState.steps();
  const workspaceError = imagineStore.use.workspaceState.error();

  const fetchData = async () => {
    const response = await aiServiceFetch(
      `/api/projects/${projectId}/preview`,
      {
        method: "GET",
      },
    );

    if (!response.ok) {
      throw await HttpError.fromResponse(response);
    }

    const data = await response.json();
    return data;
  };

  const hasWorkspaceState = workspaceStateSteps?.length > 0;

  const enabled = Boolean(
    !isReadonly &&
    !!projectId &&
    !previewUrl &&
    !isGenerating &&
    !isGeneratingNewProject &&
    !hasWorkspaceState &&
    !workspaceError &&
    isRealtimeConnected &&
    project,
  );

  return useQuery({
    queryKey: ["project-preview", projectId],
    queryFn: fetchData,
    enabled: !disabled && enabled,
    retry: false,
    refetchOnWindowFocus: false,
    refetchInterval: false,
    staleTime: Infinity,
  });
};
